import { TextFieldProps } from '@mui/material';
import React from 'react';

import { einNumberFormat } from '../../../domain/fleet';
import { TooltipAdornment } from '../../tooltip/TooltipAdornment';
import { FormikNumberFormatField } from '../formik-number-format-field';

type Props = Omit<React.ComponentProps<typeof FormikNumberFormatField>, 'InputProps'>;

const FormikEinField: React.FC<Props> = (props) => {
  const inputProps: TextFieldProps['InputProps'] = {
    endAdornment: (
      <TooltipAdornment
        ariaLabel="ein tooltip"
        title="Your Employer Identification Number (EIN),
        also known as a Taxpayer Identification Number or tax ID,
        is used to identify your business. It can be found in your EIN
        confirmation letter, your previously filed tax returns, and other 
        tax notices from the IRS."
        leaveTouchDelay={30000}
      />
    ),
  };

  return <FormikNumberFormatField InputProps={inputProps} format={einNumberFormat} {...props} />;
};

export { FormikEinField };
